import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/couple-on-patio.webp';
import imageMobileWebp from './images/couple-on-patio-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='income-annuities-financial-planning'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent={false}
      // content
      subHeadingText={<>Make a plan for <WidowBlock>tomorrow today.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            When you work with Northwestern Mutual, we listen to the goals you have and design a financial plan tailored specifically to your life. An income annuity could be an important part of that plan, giving you a guaranteed stream of income that will take you all the way through your retirement. Find out more about how we plan.
          </Typography>
          <Link
            id='financial-planning-section-cta'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/financial-planning/'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='a happy couple hugging on their patio'
      imageSrcDefault={imageDesktopWebp}
      imageSrcMobile={imageMobileWebp}
    />
  );
};
